import { DeviceDetect } from "../../contracts";
import { buildDefaultLiveMobileProps, buildDefaultLiveDesktopProps, buildPreLiveProps, buildSoccerLiveDesktopProps, buildSoccerLiveMobileProps, buildBasketballLiveMobileProps, buildBasketballLiveDesktopProps, buildIceHockeyLiveMobileProps, buildIceHockeyLiveDesktopProps, buildOnServeLiveMobileProps, buildOnServeLiveDesktopProps, buildTennisLiveMobileProps, buildTennisLiveDesktopProps, buildVolleyballLiveMobileProps, buildVolleyballLiveDesktopProps, buildBaseballLiveMobileProps, buildBaseballLiveDesktopProps, buildAmericanFootballLiveMobileProps, buildAmericanFootballLiveDesktopProps } from "../../builders";
export const createScoreboardProps = (event, config) => {
    const propsBuilder = getPropsBuilder(event);
    return {
        command: propsBuilder.componentName,
        data: propsBuilder.builder(event, config)
    };
};
const buildProps = (componentName, builder) => {
    return {
        componentName,
        builder
    };
};
const commandToPropsBuilder = {
    LiveIsMobile0: buildProps("DefaultLiveScoreboardMobile", buildDefaultLiveMobileProps),
    LiveIsTablet0: buildProps("DefaultLiveScoreboardMobile", buildDefaultLiveMobileProps),
    LiveIsDesktop0: buildProps("DefaultLiveScoreboardDesktop", buildDefaultLiveDesktopProps),
    LiveIsMobile2: buildProps("DefaultLiveScoreboardMobile", buildBasketballLiveMobileProps),
    LiveIsTablet2: buildProps("DefaultLiveScoreboardMobile", buildBasketballLiveMobileProps),
    LiveIsDesktop2: buildProps("DefaultLiveScoreboardDesktop", buildBasketballLiveDesktopProps),
    PreLiveIsMobile0: buildProps("DefaultPreLiveScoreboard", buildPreLiveProps),
    PreLiveIsTablet0: buildProps("DefaultPreLiveScoreboard", buildPreLiveProps),
    PreLiveIsDesktop0: buildProps("DefaultPreLiveScoreboard", buildPreLiveProps),
    LiveIsMobile1: buildProps("SoccerLiveScoreboardMobile", buildSoccerLiveMobileProps),
    LiveIsTablet1: buildProps("SoccerLiveScoreboardMobile", buildSoccerLiveMobileProps),
    LiveIsDesktop1: buildProps("SoccerLiveScoreboardDesktop", buildSoccerLiveDesktopProps),
    LiveIsMobile8: buildProps("DefaultLiveScoreboardMobile", buildIceHockeyLiveMobileProps),
    LiveIsTablet8: buildProps("DefaultLiveScoreboardMobile", buildIceHockeyLiveMobileProps),
    LiveIsDesktop8: buildProps("DefaultLiveScoreboardDesktop", buildIceHockeyLiveDesktopProps),
    LiveIsMobile26: buildProps("OnServeLiveScoreboardMobile", buildOnServeLiveMobileProps),
    LiveIsTablet26: buildProps("OnServeLiveScoreboardMobile", buildOnServeLiveMobileProps),
    LiveIsDesktop26: buildProps("OnServeLiveScoreboardDesktop", buildOnServeLiveDesktopProps),
    LiveIsMobile34: buildProps("OnServeLiveScoreboardMobile", buildOnServeLiveMobileProps),
    LiveIsTablet34: buildProps("OnServeLiveScoreboardMobile", buildOnServeLiveMobileProps),
    LiveIsDesktop34: buildProps("OnServeLiveScoreboardDesktop", buildOnServeLiveDesktopProps),
    LiveIsMobile59: buildProps("OnServeLiveScoreboardMobile", buildOnServeLiveMobileProps),
    LiveIsTablet59: buildProps("OnServeLiveScoreboardMobile", buildOnServeLiveMobileProps),
    LiveIsDesktop59: buildProps("OnServeLiveScoreboardDesktop", buildOnServeLiveDesktopProps),
    LiveIsMobile6: buildProps("OnServeLiveScoreboardMobile", buildTennisLiveMobileProps),
    LiveIsTablet6: buildProps("OnServeLiveScoreboardMobile", buildTennisLiveMobileProps),
    LiveIsDesktop6: buildProps("OnServeLiveScoreboardDesktop", buildTennisLiveDesktopProps),
    LiveIsMobile19: buildProps("OnServeLiveScoreboardMobile", buildVolleyballLiveMobileProps),
    LiveIsTablet19: buildProps("OnServeLiveScoreboardMobile", buildVolleyballLiveMobileProps),
    LiveIsDesktop19: buildProps("OnServeLiveScoreboardDesktop", buildVolleyballLiveDesktopProps),
    LiveIsMobile7: buildProps("BaseballLiveScoreboardAnimateMobile", buildBaseballLiveMobileProps),
    LiveIsTablet7: buildProps("BaseballLiveScoreboardMobile", buildBaseballLiveMobileProps),
    LiveIsDesktop7: buildProps("BaseballLiveScoreboardDesktop", buildBaseballLiveDesktopProps),
    LiveIsMobile3: buildProps("DefaultLiveScoreboardMobile", buildAmericanFootballLiveMobileProps),
    LiveIsTablet3: buildProps("DefaultLiveScoreboardMobile", buildAmericanFootballLiveMobileProps),
    LiveIsDesktop3: buildProps("DefaultLiveScoreboardDesktop", buildAmericanFootballLiveDesktopProps)
};
const getPropsBuilder = (event) => {
    const baseCommand = `${event.isLive ? "Live" : "PreLive"}${DeviceDetect.getInstance().deviceTypeValue}`;
    const command = `${baseCommand}${event.sportId}`;
    return commandToPropsBuilder[command] || commandToPropsBuilder[`${baseCommand}0`];
};
//# sourceMappingURL=createScoreboardProps.js.map